import { ColDef, ColGroupDef } from "ag-grid-enterprise";
import { DateFilter, DateUtils } from "utils/dateutils";
import {
  criticalActivityHeaderComponent,
  criticalActivityIndicatorCellRenderer,
  truncatedTextCellRenderer
} from "components/cell-renders";
import { GanttActivityTypes } from "constants/index";
import { TActivityTask } from "../models";
import {
  getLinkedMaterialGetterData,
  getLinkedSubmittalGetterData,
  valueGetterActivityCritical
} from "../utils/value-getters";

export const activityColDefs = [
  {
    colId: "source_task_id",
    field: "source_task_id",
    headerName: "Activity ID",
    headerTooltip: "Activity ID",
    cellRenderer: "agGroupCellRenderer",
    tooltipField: "source_task_id",
    filter: true,
    getQuickFilterText: (params) => {
      const { value, data, context } = params;
      let allValues = [value];
      data.linked_materials.forEach((m) => {
        allValues = allValues.concat(getLinkedMaterialGetterData({ data: m }));
        m.linked_submittals.forEach((s) => {
          allValues = allValues.concat(
            getLinkedSubmittalGetterData({ data: s.submittal, context })
          );
        });
      });

      data.linked_submittals.forEach((s) => {
        allValues = allValues.concat(
          getLinkedSubmittalGetterData({ data: s, context })
        );
      });
      return allValues.join(" ");
    }
  },
  {
    colId: "text",
    field: "text",
    headerName: "Activity Name",
    headerTooltip: "Activity Name",
    cellRenderer: truncatedTextCellRenderer
  },
  {
    colId: "start_date",
    field: "start_date",
    headerName: "Start Date",
    headerTooltip: "Start Date",
    comparator: DateFilter.comparator,
    valueGetter: ({ data }) =>
      data?.start_date ? DateUtils.format(data.start_date) : "",
    sort: "asc",
    cellRenderer: truncatedTextCellRenderer
  },
  {
    colId: "end_date",
    field: "end_date",
    headerName: "End Date",
    headerTooltip: "End Date",
    comparator: DateFilter.comparator,
    valueGetter: ({ data }) =>
      data?.end_date ? DateUtils.format(data.end_date) : "",
    cellRenderer: truncatedTextCellRenderer
  },
  {
    colId: "duration",
    field: "duration",
    headerName: "Duration",
    headerTooltip: "Duration",
    valueGetter: ({ data }) => {
      const duration = Math.floor((data?.duration || 0) / 8);
      return duration;
    },
    cellRenderer: truncatedTextCellRenderer
  },
  {
    colId: "critical",
    field: "critical",
    headerName: "Critical Activity",
    headerTooltip: "Critical Activity",
    headerComponentParams: criticalActivityHeaderComponent,
    cellRenderer: criticalActivityIndicatorCellRenderer,
    filter: "agSetColumnFilter",
    filterParams: {
      valueFormatter: valueGetterActivityCritical,
      comparator: (valA: any, valB: any) => {
        if (valA === valB) return 0;
        return valA > valB ? -1 : 1;
      }
    },
    minWidth: 90,
    maxWidth: 90
  },
  {
    colId: "total_slack",
    field: "total_slack",
    headerName: "Activity Float",
    headerTooltip: "Activity Float",
    cellStyle: (params) => {
      if (params?.data?.critical) {
        return { fontWeight: "bold" };
      }
      return { fontWeight: "normal" };
    },
    valueGetter: (params: any) => {
      if (
        params?.data?.total_slack === null ||
        params.data.type === GanttActivityTypes.Wps
      )
        return "";
      const float = Math.floor((params?.data?.total_slack || 0) / 8);
      return `${float} days`;
    },
    cellRenderer: truncatedTextCellRenderer
  }
] as (ColDef<TActivityTask> | ColGroupDef<TActivityTask>)[];
